export default "__VITE_ASSET__DLLK5ogz__"